import clsx from 'clsx';

import { useTranslation } from 'react-i18next';

import baseStyles from '../../base.module.css';

type Props = {
  title: string;
  englishTitle: string;
  children: React.ReactNode;
  className: string;
};

export const ContentSection = ({ title, englishTitle, children, className }: Props) => {
  const { i18n } = useTranslation();

  return (
    <section className={clsx(baseStyles['base-column__main__section'], className)}>
      <div className={baseStyles['base-column__ttl']}>
        <h2>
          <h2 className="base-key__text">{title}</h2>
          {i18n.language !== 'en-US' && <p>{englishTitle}</p>}
        </h2>
      </div>

      {children}
    </section>
  );
};
